import { render, staticRenderFns } from "./rule_list.html?vue&type=template&id=4ded675d&scoped=true&name=rule_list&external"
import script from "./rule_list.js?vue&type=script&lang=js&external"
export * from "./rule_list.js?vue&type=script&lang=js&external"
import style0 from "./rule_list.less?vue&type=style&index=0&id=4ded675d&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ded675d",
  null
  
)

export default component.exports